var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdpi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 281.1 118.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u05D3\\u05E3_\\u05D4\\u05D1\\u05D9\\u05EA",
    "data-name": "\\u05D3\\u05E3 \\u05D4\\u05D1\\u05D9\\u05EA"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.08,21.18h-11.16v26.82H8.88v-9.18h6.72v-17.64h-4.92v-9.18h36.72v36h-10.32v-26.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.42,12h10.32v36h-10.32V12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.52,12h10.32v19.68h-10.32V12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.94,30c0-10.8,8.22-19.14,19.2-19.14s19.08,8.34,19.08,19.14-8.16,19.14-19.08,19.14-19.2-8.34-19.2-19.14ZM115.14,39.66c4.98,0,8.76-4.14,8.76-9.66s-3.78-9.66-8.76-9.66-8.88,4.14-8.88,9.66,3.78,9.66,8.88,9.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.74,38.82V12h10.26l.06,36h-20.04v-9.18h9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.04,21.18h-17.4v-9.18h27.72v36h-10.32v-26.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.28,39.66c5.16,0,8.94-4.02,8.94-9.66,0-8.1-5.64-11.22-11.7-8.58l-2.7-8.46c12.9-5.22,24.72,1.62,24.72,17.04,0,11.16-8.16,19.14-19.26,19.14s-19.38-7.98-19.38-19.14V12h10.32v18c0,5.64,3.78,9.66,9.06,9.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.12,6.6h10.32v5.4h21.24l-15.54,37.02-9.42-3.78,10.2-24.06h-16.8V6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.34,56.6h10.32v5.4h21.24l-15.54,37.02-9.42-3.78,10.2-24.06h-16.8v-14.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.36,83.18v14.82h-10.32v-37.38h.18l15.84,14.22,11.28-14.28,8.28,6.24-12.06,14.76,11.88,10.68-6.96,7.56-18.12-16.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.9,71.18h-17.4v-9.18h27.72v36h-10.32v-26.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.24,62v17.64c0,12.12-7.92,19.5-21.12,19.5s-21.12-7.38-21.12-19.5v-17.64h10.14v9.66h5.94v-9.66h9.72v18.6h-15.6c.36,5.7,4.5,9.06,10.92,9.06,6.78,0,10.98-3.72,10.98-10.02v-17.64h10.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.78,62h10.32v19.68h-10.32v-19.68Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdpi);
export default __webpack_public_path__ + "static/media/לטרנסיות ישראלmdpi.014dee6fce544447ef839842eeb5640f.svg";
export { ForwardRef as ReactComponent };